export type ValidationErrorProps = {
  message?: string;
};

export function ValidationError(props: Readonly<ValidationErrorProps>) {
  if (!props.message) {
    return null;
  }

  return <p className="mt-1 text-red-500 text-sm">{props.message}</p>;
}
